import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { useHistory } from 'react-router-dom';
// import Button from 'web/components/Button';
import styled from 'styled-components';
import './breadCrumb.scss';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
// import HomeIcon from '@material-ui/icons/Home';
const useStyles = makeStyles((theme) => ({
  root: {
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

const Breadcrumb = ({ breadcrumbArr, selected, title, fromPage, callBackToParentPage }) => {
  let history = useHistory();
  const classes = useStyles();

  const handleClick = (event, item) => {
    event.preventDefault();
    if(fromPage === 'myPostedPalletNeeds' || fromPage === 'myPostedPalletInv'){
      callBackToParentPage(item)
    }else{
      history.push(item.link);
    }
  }


  return (
    <SectionContainer>
      <div className="title">{title}</div>

      <div className={classes.root}>
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
          {breadcrumbArr.map((item, index) => (
            <>{item.name === "PT+ Admin1"?<>
             {item.name}
             </>:
             <>
             {item.eventType === "Click" ? <Link
                className='nav-links'
                onClick={() => {
                  history.goBack();
                }}> {item.name}</Link> :
                <Link color="inherit" href={item.link} onClick={(e) => handleClick(e, item)}>
                  {item.name}
                </Link>
              }            
            </>}
            </>
          ))}
          <Typography color="textPrimary">{selected}</Typography>
        </Breadcrumbs>
      </div>

    </SectionContainer>
  );
}
export default Breadcrumb;

const SectionContainer = styled.div`
  .MuiBreadcrumbs-ol {
    margin: 10px 0;
  }
`;

// const HomeIconWrapper = styled.div``